import React from "react";
import HomeCarousel from "@components/Home/CarouselHome";
import {
  FOR_YOU_PAGE_LIMIT,
  ForYouData,
  useForYou,
} from "@hooks/trpc/useForYou";
import { captureException } from "@utils/captureException";
const ForYou = () => {
  const { data, fetchNextPage, hasNextPage } = useForYou();
  const items: ForYouData[] = data.pages.flatMap((page) => page.data);

  const handleEndReached = () => {
    if (hasNextPage) {
      fetchNextPage().catch((error) => {
        captureException(error, {
          channel: "breadcrumb",
          area: "pagination",
          operation: "fetch-next-for-you",
        });
      });
    }
  };

  return (
    <HomeCarousel
      items={items}
      onEndReached={handleEndReached}
      onEndReachedThreshold={FOR_YOU_PAGE_LIMIT}
      screen="home"
      title="For you"
    />
  );
};

export default ForYou;
